import { render, staticRenderFns } from "./WikiDetail.vue?vue&type=template&id=6a98575e"
import script from "./WikiDetail.vue?vue&type=script&lang=js"
export * from "./WikiDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports